import "./report.scss";

import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { columnsCsv, options } from "./user-contents";

import RakPresentational from "./rakprofilesPresentational";
import { getProfilesList } from "./utils";
import moment from "moment";
import { profileData } from "./data.js";

const rakprofiles = () => {
  const history = useHistory();
  const request = {
    page: 1,
    size: 10,
    name:"",
    mobile: "",
    companyName: "",
    branchId: "",
    status: "",
    emiratesId:"",
    fromDate: "",
    toDate: "",
    applicationId: 1,
  };
  const [filterForm, setFilterForm] = useState(request);
  const [modalShow, setModalShow] = useState(false);
  const [infoModalShow, setinfoModalShow] = useState(false);
  const [searchBy, setSearchBy] = useState("mobile");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState();
  const [blockStatus, setBlockStatus] = useState(false);
  const [verifiedStatus, setVerifiedStatus] = useState(false);
  const [activeStatus, setActiveStatus] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [profileList, setProfilesList] = useState([]);
  const[currentStatus,setCurrentStatus]=useState("")
  const[description,setDescription]=useState("")
  const[filename,setFileName]=useState("")
  const [allUserListExcel, setallUserProfileListExcel] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [sizeShow, setSizeShow] = useState();
  const buttonRef = useRef("");

  const columns = [
    {
      dataField: "",
      text: "",
      sort: false,
      style: { minWidth: "15px", textAlign: "center" },
      formatter: (cell, row) => {
        let states = { ...row };
        return (
          <div
            style={{ color: "black" }}
            onClick={() => {setinfoModalShow(true);
            setCurrentStatus(row.status);
            setDescription(row.description);
            setFileName(row.fileName);}}
          >
            <i style={{ fontSize: 18 }} className="fas fa-search" />
          </div>
        );
      },
    },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.date) || null).format("DD-MM-YY HH:mm:ss");
      },
    }, {
      dataField: "name",
      text: "name",
      sort: false,
      style: { minWidth: "200px", textAlign: "Left" },
    },
    
    {
      dataField: "companyName",
      text: "companyName",
      sort: false,
      style: { minWidth: "200px", textAlign: "Left" },
    },
    {
      dataField: "mobile",
      text: "Mobile",
      sort: false,
      style: { minWidth: "120px", textAlign: "center" },
      headerStyle:{textAlign: "center"}
    },
    {
      dataField: "branchId",
      text: "branchId",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "160px", textAlign: "center" },
    },
    {
      dataField: "emiratesId",
      text: "EmiratesId",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "130px", textAlign: "center" },
    },
    {
      dataField: "status",
      text: "status",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "130px", textAlign: "center" },
    },
    
  
   
  ];

  const rowOnClick =  {
    onClick: (e, row, rowIndex) => {setinfoModalShow(true);
    setCurrentStatus(row.status);
    setDescription(row.description);
    setFileName(row.fileName);
   }}

  useEffect(() => {
    if (filterForm) {
      getAllProfile(filterForm);
    }
  }, [filterForm]);

  const getAllProfile = (request) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getProfilesList(request)
      .then((res) => {
        
                
        setDataLoading(false);
        if (res && res.data && res.data.rakProfiles.length > 0) {
          setProfilesList(() => res.data.rakProfiles);
          console.log("Response",profileList)
          
          
        
        } else {
          setProfilesList([]);
        }
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {

       
        setProfilesList([]);
        setDataLoading(false);
        
      });
  };

  const resetFilter = () => {
    setSearchBy("mobile");
    // setSearchByValue('');
    setFiltersSelected(false);
    setProfilesList([]);
    setallUserProfileListExcel([]);
    setFromDate(null);
    setToDate(null);
    setSelectedOption("");
    setFilterValues(false);
    setSearchByValue("");
    setFilterForm(request);
  };

  const handleFIlter = () => {
    let request = {};
    if (searchBy === "mobile") {
      request = {
        ...filterForm,
        mobile: searchByValue.trim(),
        companyName: "",
        branchId: "",
  
        status: "",
      };
    } 
    else if (searchBy === "emiratesId") {
    
      request = {
        ...filterForm,
        emiratesId: searchByValue.trim(),
        mobile: "",
        companyName: "",
      
        status: "",
      };
    }else if (searchBy === "branchId") {
      request = {
        ...filterForm,
        branchId: searchByValue.trim(),
        mobile: "",
        companyName: "",
      
        status: "",
      };
    }
    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();
    request.status = "";
    let a = "";
    if (selectedOption.length > 0) {
      selectedOption.forEach((v, i) => {
        a = a + v.value + (i + 1 < selectedOption.length ? "," : "");
      });
    }
    request.page = 1;
    request.status = a; // TODO - NEED TO REMOVE
    setFilterForm(request);
  };

  const handleChange = (selectedOption) => {
    console.log(selectedOption);
    if (selectedOption) {
      setSelectedOption([...selectedOption]);
    } else {
      setSelectedOption("");
    }
  };
  const statusFilter = () => {
    setNoOfFiltersSelected(selectedOption.length);
    setModalShow(false);
    setFiltersSelected(true);
    selectedOption.map((option) => {
      switch (option.label) {
        case "Rejected":
          setBlockStatus(true);
          return setFilterValues(!filterValues);
        case "Created":
          setVerifiedStatus(true);
          return setFilterValues(!filterValues);
        case "Pending":
          setVerifiedStatus(true);
          return setFilterValues(!filterValues);
          case "Updated":
          setVerifiedStatus(true);
          return setFilterValues(!filterValues);

        default:
          return "";
      }
    });
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "emiratesId") {
    searchByValuePlaceholder = "12xxxxxxxxxxx";
  } else if (searchBy === "mobile") {
    searchByValuePlaceholder = "971xxxxxxxxx";
  } else if (searchBy === "branchId") {
    searchByValuePlaceholder = "99999";
  }  else {
    searchByValuePlaceholder = "1234567890";
  }

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = 1;
    request.size = "";
    getProfilesList(request)
      .then((res) => {
        if (res && res.data && res.data.rakProfiles.length > 0) {
          let data = res.data.rakProfiles.map((element) => {
            if (element.registrationDate) {
              element.registrationDate = moment(
                element.registrationDate
              ).format("DD-MM-YYYY");
            }
            return element;
          });
          setallUserProfileListExcel(() => data);
          buttonRef.current.click();
        } else {
          setallUserProfileListExcel([]);
        }
      })
      .catch((err) => {
        setallUserProfileListExcel([]);
      });
  };

  console.log("profileData 222", profileData);
  return (
    <RakPresentational
      searchBy={searchBy}
      rowOnClick={rowOnClick}
      currentStatus={currentStatus}
      description={description}
      filename={filename}
      setSearchByValue={setSearchByValue}
      setSearchBy={setSearchBy}
      searchByValuePlaceholder={searchByValuePlaceholder}
      searchByValue={searchByValue}
      fromDate={fromDate}
      setFromDate={setFromDate}
      toDate={toDate}
      setToDate={setToDate}
      setModalShow={setModalShow}
      filtersSelected={filtersSelected}
      noOfFiltersSelected={noOfFiltersSelected}
      resetFilter={resetFilter}
      handleFIlter={handleFIlter}
      filterValues={filterValues}
      profileData={profileList}
      dataLoading={dataLoading}
      buttonRef={buttonRef}
      filterForm={filterForm}
      onExcelClciked={onExcelClciked}
      allUserListExcel={allUserListExcel}
      columns={columns}
      columnsCsv={columnsCsv}
      pagination={pagination}
      setFilterForm={setFilterForm}
      setSizeShow={setSizeShow}
      modalShow={modalShow}
      infoModalShow={infoModalShow}
      setinfoModalShow={setinfoModalShow}
      handleChange={handleChange}
      options={options}
      selectedOption={selectedOption}
      statusFilter={statusFilter}
    />
  );
};

export default rakprofiles;
